<!-- 数据概览 -->
<template>
  <div class="overview">
    <div class="container">
      <!-- 面包屑 -->
      <div class="bread">
        <span class="bread-tab">数据中心</span>
      </div>
      <!-- 内容 -->
      <div class="show-box">
        <div class="show-search">
          <!-- 搜索 -->
          <div class="search-item">
            <span class="search-label">区域：</span>
            <el-cascader
              v-model="dataForm.area"
              :props="{ checkStrictly: true }"
              :options="arealist"
              clearable
              size="small"
              placeholder="请选择区域"
              @change="handleChange"
            ></el-cascader>
          </div>
          <div class="search-item">
            <span class="search-label">日期：</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="starttime"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <span class="content-date-interval">至</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="endtime"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
          <div class="search-item">
            <el-button class="oper-button" size="small" @click="search()"
              >搜索</el-button
            >
            <el-button class="oper-button" size="small" @click="reset()"
              >重置</el-button
            >
          </div>
        </div>
        <!-- 数据内容展示 -->
        <div class="show-data">
          <!-- 上面数据展示 -->
          <div class="total-list clearfix">
            <div class="total-item">
              <div class="item-content">
                <span
                  class="content-number"
                  v-loading="loading"
                >
                  {{ datalist.enterpriseNum || "--"}}</span
                >
                <span class="content-title">组织团委总数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span
                  class="content-number"
                  v-loading="loading"
                  >{{ datalist.unitList && datalist.unitList.length > 0 ? datalist.unitList[0].num || '--' : "--" }}</span
                >
                <span class="content-title">入驻团委总数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.projectNum || "--"
                }}</span>
                <span class="content-title">项目总数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.unitNum || "--"
                }}</span>
                <span class="content-title">用人单位总数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.postNum || "--"
                }}</span>
                <span class="content-title">岗位总数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.enrollNum || "--"
                }}</span>
                <span class="content-title">招募人数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.passNum || "--"
                }}</span>
                <span class="content-title">录取人数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.joinNum || "--"
                }}</span>
                <span class="content-title">报名人次</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.signNum || "--"
                }}</span>
                <span class="content-title">报到人数</span>
              </div>
            </div>
            <div class="total-item">
              <div class="item-content">
                <span class="content-number" v-loading="loading">{{
                  datalist.schoolNum || "--"
                }}</span>
                <span class="content-title">参与高校数</span>
              </div>
            </div>
          </div>
          <!-- 下面数据展示 -->
          <div
            class="total-detalis clearfix"
            v-if="datalist && datalist.unitList"
          >
            <!-- <template v-for="(item, index) of datalist.unitList">
              <div class="detalis-item" v-if="index != 0" :key="index">
                <span class="detalis-number">{{ item.num || "0" }}</span>
                <span class="detalis-name">{{ item.name || "--" }}</span>
                <span v-if="index!=0" class="detalis-name">{{ item.name || '--' }}</span>
                <span v-if="index!=0" class="detalis-number">{{ item.num || '0' }}</span>
              </div>
            </template> -->
          </div>
          <!-- 地图数据 -->
          <div class="total-map">
            <div ref="dataMap" class="dataMap"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  Input,
  DatePicker,
  Button,
  Cascader
} from 'element-ui'
export default {
  components: {
    'el-select': Select,
    'el-option': Option,
    'el-input': Input,
    'el-date-picker': DatePicker,
    'el-button': Button,
    'el-cascader': Cascader
  },
  data () {
    return {
      arealist: [],
      dataForm: {
        area: '',
        date: [],
        provinceId: '',
        cityId: '',
        areaId: ''
      },
      datalist: {},
      postMapdata: [],
      starttime: null,
      endtime: null,
      loading: true
    }
  },
  created () {
    let nowYear = new Date().getFullYear()
    let startDate = new Date(nowYear, 0, 1, 0, 0, 0)
    let endDate = new Date(nowYear, 11, 31, 23, 59, 59)
    // 开始时间获取年月日时分秒
    var startyear = startDate.getFullYear()
    var startmonth = startDate.getMonth() + 1
    var startday = startDate.getDate()
    // var starthour = startDate.getHours()
    // var startminute = startDate.getMinutes()
    // var startsecond = startDate.getSeconds()
    // 结束时间获取年月日时分秒
    var endyear = endDate.getFullYear()
    var endmonth = endDate.getMonth() + 1
    var endday = endDate.getDate()
    // var endhour = endDate.getHours()
    // var endminute = endDate.getMinutes()
    // var endsecond = endDate.getSeconds()
    let startResetDate =
      this.formatTen(startyear) +
      '-' +
      this.formatTen(startmonth) +
      '-' +
      this.formatTen(startday)
      // +
      // " " +
      // this.formatTen(starthour) +
      // ":" +
      // this.formatTen(startminute) +
      // ":" +
      // this.formatTen(startsecond);
    let endResetDate =
      this.formatTen(endyear) +
      '-' +
      this.formatTen(endmonth) +
      '-' +
      this.formatTen(endday)
      //  +
      // " " +
      // this.formatTen(endhour) +
      // ":" +
      // this.formatTen(endminute) +
      // ":" +
      // this.formatTen(endsecond);
    if (startResetDate && endResetDate) {
      this.starttime = startResetDate
      this.endtime = endResetDate
    }
    // 获取省市区三级联动数据
    this.getAreainfo(res => {
      this.arealist = res
    })
  },
  mounted () {
    this.init()
    this.getChinaMap().then(res => {
      this.getPostMap(res)
    })
  },
  methods: {
    init () {
      this.datalist = {}
      this.loading = true
      let data = {
        provinceId: this.dataForm.provinceId || '',
        cityId: this.dataForm.cityId || '',
        areaId: this.dataForm.areaId || '',
        starttime: this.starttime ? `${this.starttime} 00:00:00` : '',
        endtime: this.endtime ? `${this.endtime} 23:59:59` : ''
      }
      this.$http({
        method: 'POST',
        url: '/data/summarize',
        params: data
      })
        .then(res => {
          if (+res.code === 100) {
            this.datalist = res.result
          } else {
            this.$message.error(res.msg || res.result.msg || '请求超时请稍后再试')
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
          return false
        })
    },
    // 搜索
    search () {
      this.init()
      this.getChinaMap().then(res => {
        this.getPostMap(res)
      })
    },
    // 重置
    reset () {
      Object.assign(this.$data.dataForm, this.$options.data().dataForm)
      this.starttime = null
      this.endtime = null
      this.init()
      this.getChinaMap().then(res => {
        this.getPostMap(res)
      })
    },
    // 省市区三级联动选择事件
    handleChange (item) {
      this.dataForm.provinceId = item[0] || ''
      this.dataForm.cityId = item[1] || ''
      this.dataForm.areaId = item[2] || ''
    },
    // 时间补位
    formatTen (num) {
      return num > 9 ? num + '' : '0' + num
    },
    // 获取地图数据
    getChinaMap () {
      return new Promise((resolve, reject) => {
        this.$http({
          method: 'POST',
          url: '/common/province'
        })
          .then(res => {
            if (res.code === 100) {
              resolve(res.result)
            } else {
              this.$message.error(res.msg || res.result.msg)
              return false
            }
          })
          .catch(error => {
            console.log(error)
            return false
          })
      })
    },
    // 获取地图岗位数据
    getPostMap (maplist) {
      let data = {
        starttime: this.starttime ? `${this.starttime} 00:00:00` : '',
        endtime: this.endtime ? `${this.endtime} 23:59:59` : ''
      };
      this.$http({
        method: 'POST',
        url: '/data/summarize/map',
        params: data
      })
        .then(res => {
          if (res.code === 100) {
            this.postMapdata = []
            if (maplist.length > 0) {
              for (let i = 0; i < maplist.length; i++) {
                let checkItem = res.result.find(item => item.label == maplist[i].value)
                //console.log(checkItem)
                let item = {
                  name: maplist[i].label,
                  value: checkItem && checkItem.value !== undefined ? checkItem.value : '0'
                }
                this.postMapdata.push(item)
              }
            }
            this.initMap(this.postMapdata)
          } else {
            this.$message.error(res.msg || res.result.msg)
            return false
          }
        })
        .catch(error => {
          console.log(error)
          return false
        })
    },
    // 地图初始化
    initMap (mapPostdata) {
      let _ = this
      let myChart = this.echarts.init(this.$refs.dataMap)
      let option = {
        title: {
          left: 'center',
          padding: [15, 10],
          text: '岗位数量分布图',
          textStyle: {
            color: '#333333',
            fontStyle: 'normal',
            fontWeight: 'bold',
            fontSize: 16
          }
        },
        tooltip: {
          triggerOn: 'click',
          formatter: function (e, t, n) {
            return e.seriesName + '<br />' + e.name + '：' + e.value;
          }
        },
        visualMap: {
          min: 0,
          max: 1000000,
          left: 26,
          bottom: 40,
          showLabel: !0,
          text: ['多', '少'],
          pieces: [
            {
              max: 1000000,
              min: 101,
              label: '> 100 人',
              color: '#268611'
            },
            {
              min: 50,
              max: 100,
              label: '50 - 100人',
              color: '#33b517'
            },
            {
              min: 10,
              max: 49,
              label: '10 - 49 人',
              color: '#6cf74e'
            },
            {
              min: 1,
              max: 9,
              label: '1 - 9',
              color: '#a3f392'
            },
            {
              value: 0,
              color: '#f6f6f6'
            }
          ],
          show: !0
        },
        geo: {
          map: 'china',
          roam: !1,
          scaleLimit: {
            min: 1,
            max: 2
          },
          zoom: 1.2,
          top: 80,
          label: {
            normal: {
              show: !0,
              fontSize: '12',
              color: 'rgba(0,0,0,0.7)'
            }
          },
          itemStyle: {
            normal: {
              // shadowBlur: 50,
              // shadowColor: 'rgba(0, 0, 0, 0.35)',
              borderColor: 'rgba(0, 0, 0, 0.35)'
            },
            emphasis: {
              areaColor: '#f2d5ad',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [
          {
            name: '岗位数量',
            type: 'map',
            geoIndex: 0,
            data: mapPostdata
          }
        ]
      }
      //console.log(mapPostdata)
      myChart.setOption(option)
    }
  }
};
</script>
<style lang="scss" src="./overview.scss" scoped></style>
<style lang="scss" scoped>
.content-date-item {
  display: inline-block;

  >>> .el-input--suffix {
    .el-input__inner {
      padding-left: 32px;
    }
  }
}
.content-date-interval {
  padding: 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/data/overview.vue